import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=0f504b14&scoped=true&"
import script from "./PageTitle.vue?vue&type=script&lang=ts&"
export * from "./PageTitle.vue?vue&type=script&lang=ts&"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=0f504b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f504b14",
  null
  
)

export default component.exports